import { render, staticRenderFns } from "./AnyWalletOffer.vue?vue&type=template&id=308bfc84&scoped=true&"
import script from "./AnyWalletOffer.vue?vue&type=script&lang=js&"
export * from "./AnyWalletOffer.vue?vue&type=script&lang=js&"
import style0 from "./AnyWalletOffer.vue?vue&type=style&index=0&id=308bfc84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308bfc84",
  null
  
)

export default component.exports